let didScroll
let lastScrollTop = 0
let delta = 5
let navbarHeight = 96

setInterval(function () {
  if (didScroll) {
    hasScrolled()
    didScroll = false
  }
}, 250)

function hasScrolled () {
  let st = $(this).scrollTop()

  // Make sure they scroll more than delta
  if (Math.abs(lastScrollTop - st) <= delta)
    return

  // If they scrolled down and are past the navbar, add class .nav-up.
  // This is necessary so you never see what is "behind" the navbar.
  if (st > lastScrollTop && st > navbarHeight) {
    // Scroll Down
    $('#shopify-section-header').removeClass('nav-down').addClass('nav-up')
  } else {
    // Scroll Up
    if (st + $(window).height() < $(document).height()) {
      $('#shopify-section-header').removeClass('nav-up').addClass('nav-down')
    }
  }

  lastScrollTop = st
}

document.addEventListener('DOMContentLoaded', function (event) {

  setTimeout(() => {
    let temp = window.location.hostname
    if (temp.indexOf('fr') > -1) {
      let customerTag = document.querySelectorAll(`#customer-tag`)
      if (customerTag) {
        customerTag.forEach(tag => {
          temp = tag.value
          temp = temp.replace('#wgen#wg', '#wgfr#wg')
          tag.value = temp
        })
      }
    }
  }, 500)

  if (theme.settings.templateType !== 'index') {
    document.getElementById('shopify-section-header').style.top = '0'
  }

  if ((theme.settings.templateType !== 'page.edition-shop') && (theme.settings.templateType !== 'product') && (theme.settings.templateType !== 'collection') && (theme.settings.templateType !== 'index')) {
    document.querySelector('.site-header__hamburger').style.color = 'black'
  }

  // listener to display header when mouse reach top of the window
  // we dont want this effect on the collection page because we have the sticky filter section
  document.getElementById('PageContainer').addEventListener('mousemove', (e) => {
    if ((theme.settings.templateType !== 'collection') && (theme.settings.templateType !== 'page.edition-shop')) {
      if (e.y < 150 && (stopAnimation || notHomepageAnimation)) {

        // for blog page fixed the logo
        if ((theme.settings.templateType === 'blog2' || theme.settings.templateType === 'article2') && window.scrollY > 200) {
          setTimeout(() => {
            document.querySelector('.blog-layout__logo').style.position = 'fixed'
          }, 1000)
        }

        if (theme.settings.templateType !== 'product') {
          setColorHeader('black')
        }
        document.getElementById('shopify-section-header').style.top = '0'
      }
    }
  })
})

document.addEventListener('scroll', function (e) {

  // to control the top animation on scroll
  if (stopAnimation || notHomepageAnimation) {
    if ($(window).width() > 768) {
      didScroll = true
    }
  }

  let scrollStartAt = theme.settings.templateType === 'blog' ? 300 : 100
  if (theme.settings.templateType !== 'collection' && theme.settings.templateType !== 'blog2' && theme.settings.templateType !== 'article2' && theme.settings.templateType !== 'page.edition-shop') {
    // on mobile header sticky
    if ($(window).width() > 768) {
      if (stopAnimation || notHomepageAnimation) {
        setColorHeader('black')
        if (window.scrollY > scrollStartAt) {
          document.getElementById('shopify-section-header').style.top = '-100%'

          // 'I'm commenting this out because it was giving an error' -- Anna
          // if (theme.settings.templateType === 'blog') {
          //   setTimeout(() => {
          //     document.querySelector('.blog-layout__logo').setProperty('position', 'absolute', 'important')
          //   }, 1000)
          // }

        } else {
          document.getElementById('shopify-section-header').style.top = '0'
        }
      }
    } else {
      if ((notHomepageAnimation || (stopAnimation && !notHomepageAnimation)) && (theme.settings.templateType != 'product') && theme.settings.templateType != 'page.edition-shop') {
        document.querySelector('.header-section').style.setProperty('background-color', '#f0ebe7', 'important')
        setColorHeader('black')
      } else {
        if (theme.settings.templateType == 'product') {
          if (window.scrollY > scrollStartAt) {
            document.querySelector('.header-section').style.setProperty('background-color', '#f0ebe7', 'important')
            setColorHeader('black')
          } else {
            document.querySelector('.header-section').style.setProperty('background-color', 'transparent', 'important')
            setColorHeader('white')
          }
        }
      }
    }
  } else {
    if (theme.settings.templateType == 'page.edition-shop') {
      // when scroll set header to black with background
      if (window.scrollY > scrollStartAt) {
        setColorHeader('black')
        document.querySelector('.header-section').style.setProperty('background-color', '#f0ebe7', 'important')
      } else {
        // go back to the top, set header white, background transparent
        setColorHeader('white')
        document.querySelector('.header-section').style.setProperty('background-color', 'transparent', 'important')
      }
    }
    if (theme.settings.templateType == 'collection') {
      if ($(window).width() <= 768) {
        setColorHeader('white')
      }
    }
  }

  if (!stopAnimation) {
    if ((window.innerHeight + window.scrollY + 5) >= document.body.offsetHeight) {
      // set black colors
      setColorHeader('black')

      document.querySelector('#home-hero-image__title').style.setProperty('opacity', '1')
      if (titleAnimate_second) titleAnimate_second.kill()
      stopAnimation = true
      openMainPage()
    }
  }
})

function setColorHeader (color) {
  // set black colors
  let allLinksMenu = document.querySelectorAll('.site-header__main-menu .site-nav__link')
  allLinksMenu.forEach(link => {
    link.style.color = color
  })
  let allLinks = document.querySelectorAll('.site-nav__icons .site-nav__link')
  allLinks.forEach(link => {
    link.style.color = color
  })
  document.querySelector('.shop-link').style.color = color
  document.querySelector('.site-header__hamburger').style.color = color
  let temp = document.querySelector('.site-nav__wishlist')
  if (temp) temp.style.color = color
  temp = document.querySelector('.site-nav__wardrobe')
  if (temp) temp.style.color = color
  temp = document.querySelector('.cart-link')
  if (temp ) temp.style.color = color
  temp = document.querySelector('.site-header__menu-icon')
  if (temp) {
    let siteHeaderMenuIcon = temp
    if (siteHeaderMenuIcon) {
      siteHeaderMenuIcon.style.color = color
      siteHeaderMenuIcon.style.fill = color
    }
  }
  let logo = document.querySelectorAll('.main-logo path')
  logo.forEach(path => {
    path.style.fill = color
  })
}

function leftDrawerBumped () {
  document.getElementById('menu-drawer').classList.add('menu-drawer--bumped')
  setTimeout(() => {
    $('#menu-drawer').removeClass('menu-drawer--bumped').addClass('menu-drawer--show-portion')
  }, 1000)
}

function openDrawer (time = 500) {
  showHideWardrobePopup('hide')
  document.getElementById('menu-drawer').classList.add('menu-drawer--opened')
  document.getElementById('menu-first-panel').classList.add('menu-first-panel--slide-right')
  document.getElementById('menu-drawer__button').onclick = function () { closeDrawer() };
  setTimeout(() => {
    document.getElementById('menu-drawer').classList.add('menu-drawer--ready')
  },time)
}

function slideDrawer () {
  document.getElementById('menu-first-panel').classList.add('menu-first-panel--slide-right')
  document.getElementById('menu-drawer__button').onclick = function () { closeDrawer() };
}

function closeDrawer () {
  let menuDrawer = document.getElementById('menu-drawer')
  if (menuDrawer.classList.contains('menu-drawer--ready')) {
    // document.querySelector('.menu-drawer__overlay').style.display = 'none'
    menuDrawer.classList.remove('menu-drawer--opened')
    menuDrawer.classList.remove('menu-drawer--ready')
    setTimeout(() => {
      document.getElementById('menu-first-panel').classList.remove('menu-first-panel--slide-right')
    }, 250)
    setTimeout(() => {
      document.getElementById('menu-drawer__button').onclick = function () { slideDrawer() };
    }, 500)
  }
  showHideWardrobePopup('show')
}

function filterCollection (collectionURL, currentSelection) {
  if (currentSelection.classList.contains('pill-button--selected')) {
    document.location.href = `/collections/all`
  } else {
    document.location.href = `${collectionURL}`
  }
}

function closeCart () {
  document.dispatchEvent(new Event('cart:close'))
}

function deleteItemFromCart (itemId) {
  let addData = {
    updates: {}
  }

  addData.updates[itemId] = 0

  fetch('/cart/update.js', {
    method: 'POST',
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    },
    body: JSON.stringify(addData)
  })
    .then((response) => {
      if (response.status === 200) {
        document.dispatchEvent(new Event('cart:build'))
      }
    })
    .catch((error) => {
      console.log('catch', error)
    })
}

function goTo (url, e) {
  document.querySelector('.swym-modals-container').style.display = 'none'
  e.preventDefault()
  document.location.href = url
}

function removeBorderFilterMobile () {
  // check if mobile filters are in place, then remove border from container
  if ($(window).width() <= 768) {
    let mobileFilters = document.querySelectorAll('.collection-filter__mobile > .collection-filter__filters-active-wrapper > .tag-list--active-tags li')

    if (mobileFilters && mobileFilters.length > 0) {
      // document.querySelector('.collection-filter__inner').style.borderBottom = '0'
    } else {
      document.querySelector('.collection-filter__inner').style.borderBottom = '.5px solid #C0B7A5'
    }
  }
}

// Size Guide Toggle
function openSizeGuide() {
  const sizeGuidePopup = document.getElementById('size-guide-popup')
  if(sizeGuidePopup){
    sizeGuidePopup.classList.remove('size-guide--closed')
  }
}

function closeSizeGuide(e) {
  const sizeGuidePopup = document.getElementById('size-guide-popup')
  if (e.target === document.getElementsByClassName('size-guide__overlay')[0]) {
    if(sizeGuidePopup){
      sizeGuidePopup.classList.add('size-guide--closed')
    }
  }
  else if (e.target === document.getElementsByClassName('size-guide__close-button')[0]) {
    if(sizeGuidePopup){
      sizeGuidePopup.classList.add('size-guide--closed')
    }
  }
}


//Weglot

document.addEventListener('DOMContentLoaded', weglotSetup, false)

function weglotSetup() {
  const weglot = window.Weglot

  if (weglot) {
    document.querySelector('.weglot-container') ? weglotInit() : setTimeout(weglotInit, 1000)
  }
}

function weglotInit() {
  const weglot = window.Weglot
  document.querySelector('.weglot-container')
    ? document.querySelector('.weglot-container').style.display = 'none'
    : ''
  const languages = []
  languages.push(weglot.options.language_from)
  weglot.options.languages.forEach( lang => languages.push(lang.language_to))
  const langSelector = document.querySelector('.lang-selector')
  let optionsContent = ''
  languages.forEach(lang => {
    if (lang === 'en') {
      optionsContent += `<span data-value="${lang}" class="title-gt-12">EN</span> <span>/</span> `
    } else {
      optionsContent += `<span data-value="${lang}" class="title-gt-12">FR</span>`
    }
  })
  langSelector.innerHTML = optionsContent
  langSelector.value = weglot.getCurrentLang()
  langSelector.addEventListener('click', function(event) {
    weglot.switchTo(event.target.dataset.value)
  })

  // click event for drawer lang selector
  const drawerLangSelector = document.querySelectorAll('.drawer-lang-selector')
  drawerLangSelector.forEach(selector => {
    selector.addEventListener('click', function (event) {
      weglot.switchTo(event.target.dataset.value)
    })
  })
  // click event for mobile
  const mobileLangSelector = document.querySelectorAll('.mobile-lang-selector')
  mobileLangSelector.forEach(selector => {
    selector.addEventListener('click', function (event) {
      weglot.switchTo(event.target.dataset.value)
    })
  })

  // Fix bug for header text not changing completely white
  if (theme.settings.templateType !== 'page.collection-list'
      && theme.settings.templateType !== 'blog'
      && theme.settings.templateType !== 'page.at_your_service'
      && theme.settings.templateType !== 'page.contact'
      && theme.settings.templateType !== 'page.full-width'
      && theme.settings.templateType !== 'customers/register'
      && theme.settings.templateType !== 'product'
      && theme.settings.templateType !== 'customers/login'
      && theme.settings.templateType !== 'customers/account'
      && theme.settings.templateType !== 'account/addresses'
      && theme.settings.templateType !== 'page.return'
      && theme.settings.templateType !== 'index') {
      setColorHeader('white')
  } else if ( theme.settings.templateType == 'index' && !notHomepageAnimation) {
    setColorHeader('white')
  }
}

// hide wardrobe popup
function showHideWardrobePopup (action) {
  let wardrobePopup = document.querySelector('.wardrobe-popup')
  let wardrobePopupFloating = document.querySelector('.wardrobe-popup__float-icon')

  if (action === 'show') {
    if (wardrobePopup) {
      wardrobePopup.classList.remove('wardrobe-popup--hide')
    }
    if (wardrobePopupFloating) {
      wardrobePopupFloating.classList.remove('wardrobe-popup--hide')
    }
  } else {
    if (wardrobePopup) {
      wardrobePopup.classList.add('wardrobe-popup--hide')
    }
    if (wardrobePopupFloating) {
      wardrobePopupFloating.classList.add('wardrobe-popup--hide')
    }
  }
}

// apply filters outside the dropdown
function applyFilterExternal(elementName, element) {
  let querystring = ''
  // get all filters and add the checked ones
  let AllFilters = document.querySelectorAll('.filter-form input')
  AllFilters.forEach(filter => {
    if (filter.name === elementName) {
      if (element.checked) {
        querystring += `${filter.name}=${filter.value}&`
      }
    } else {
      if (filter.checked) {
        if (filter.name === 'filter.v.option.color') {
          // create querystring for all real colors
          querystring += filter.value.split(',').map(item => {
            return `${filter.name}=${item}`
          }).join('&')
        } else {
          querystring += `${filter.name}=${filter.value}`
        }
        querystring += '&'
      }
    }
  })

  // render the collection
  fetchCollection(querystring, true)
}

// every time a filter is added/removed
function applyFilter (keepClosed) {
  // keep any other filter already applied
  let querystring = ''
  // get all filters and add the checked ones
  let AllFilters = document.querySelectorAll('.filter-form input')
  AllFilters.forEach(filter => {
    if (filter.checked) {
      if (filter.name === 'filter.v.option.color') {
        // create querystring for all real colors
        querystring += filter.value.split(',').map(item => {
          return `${filter.name}=${item}`
        }).join('&')
      } else {
        querystring += `${filter.name}=${filter.value}`
      }
      querystring += '&'
    }
  })

  // render the collection
  fetchCollection(querystring, keepClosed)
}

// clear one filter
function clearFilter (paramName, filterValue, clearAll) {
  let filtersToCheck = null
  if (clearAll) {
    filtersToCheck = document.querySelectorAll(`.filter-form input`)
  } else {
    filtersToCheck = document.querySelectorAll(`.filter-form input[name="${paramName}"]`)
  }
  filtersToCheck.forEach(filter => {
    if (clearAll) {
      filter.checked = false
    } else {
      let temp = filter.getAttribute('internal-value')
      if (temp.toUpperCase() == filterValue.toUpperCase()) {
        filter.checked = false
      }
    }
  })

  // check if the filter dropdown is closed to keep it closed
  let filterDropdown = document.querySelector('#filters-dropdown')
  const keepClosed = (filterDropdown.style.display == 'none')

  applyFilter(keepClosed)
}

// Clear search
document.addEventListener('DOMContentLoaded', function (event) {
  setTimeout(() => {
    document.getElementById('site-header__search-input').addEventListener('input', function (evt) {
      if (this.value === '') {
        document.querySelector('.site-header__custom-clear-button').style.display = 'none'
      } else {
        document.querySelector('.site-header__custom-clear-button').style.display = 'block'
      }
    })
  },1000)
})

function clearSearchInput(event) {
  event.preventDefault()
  document.getElementById('site-header__search-input').value = ''
  event.target.style.display = 'none'
}

function atYourServiceBtn(link) {
  if (link.includes('#')) {
    const anchor = document.querySelector(`#${link.substring(link.indexOf('#') + 1)}`)
    anchor.scrollIntoView({
      behavior: 'smooth'
    })
  } else {
    window.location.href = link
  }
}

function validateCookie () {
  const cookie = getCookie('stop-animation')
  if (cookie) {
    stopAnimation = true
    notHomepageAnimation = true
    return true
  } else {
    setCookie('stop-animation', 'true', 30)
    return false
  }
}

function setCookie(name,value,days) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days*24*60*60*1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "")  + expires + "; path=/";
}
function getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for(var i=0;i < ca.length;i++) {
        var c = ca[i];
        while (c.charAt(0)==' ') c = c.substring(1,c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
    }
    return null;
}
function eraseCookie(name) {
    document.cookie = name +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}